import React from 'react'
import {compose} from 'redux'
import {Button, Grid, Typography} from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles'
import withWidth from '@material-ui/core/withWidth'
import {Link} from 'react-router'
import Hidden from '@material-ui/core/es/Hidden/Hidden'
import PropTypes from 'prop-types'
import president from '../../assets/president.png'
import construction from '../../assets/icons/construction.svg'
import trenchless from '../../assets/icons/trenchless.svg'
// import asphalt from '../../assets/icons/asphalt.svg'
import engineering from '../../assets/icons/engineering.svg'
// import tunneling from '../../assets/icons/tunneling.svg'
// import manufacturing from '../../assets/icons/manufacturing.svg'
// import emergency from '../../assets/icons/emergency.svg'
// import plantWork from '../../assets/icons/plantWork.svg'
import bg from '../../assets/landing-bg.png'
import SlideMenu from '../common/SlideMenu'
import ExternalLink from '../common/ExternalLink'

const styles = theme => ({
  paper: {
    background: theme.palette.grey['100'],
    marginTop: theme.spacing.unit * 3,
    marginRight: 'auto',
    marginBottom: theme.spacing.unit * 3,
    marginLeft: 'auto',
    maxWidth: '62.5rem',
  },
  container: {
    margin: '0 auto 30px auto',
    maxWidth: 1400,
  },
  toolbar: {
    backgroundColor: 'rgba(0,0,0, .33)',
    margin: 0,
    width: 214,
    height: 107,
    float: 'right',
    marginTop: 1,
    position: 'relative',
    textAlign: 'center',

    [theme.breakpoints.down('md')]: {
      float: 'none',
      width: '100%',
      display: 'none',
    },
  },
  '@keyframes move-lr': {
    '0%': {
      left: 214,
    },
    '100%': {
      left: -1000,
    },
  },
  dropdown: {
    maxWidth: '50%',
  },
  year50: {
    color: '#FFFFFF',
    fontSize: 21,
    fontWeight: 600,
    fontFamily: 'century-gothic',
    marginBottom: -12,
    marginTop: 10,
  },
  year50Desc: {
    color: '#FFFFFF',
    fontSize: 13,
    fontWeight: 300,
    width: '100%',
  },
  landingUser: {
    height: 220,
    width: 214,
    backgroundColor: 'rgba(0, 0, 0, 0.33)',
    float: 'right',
    marginTop: 86,
    padding: 10,
  },
  landingUserSmall: {
    backgroundColor: 'rgba(0, 0, 0, 0.33)',
    marginTop: 150,
    width: '96%',
    float: 'right',
    padding: 10,
    [theme.breakpoints.up('md')]: {
      marginBottom: 50,
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 213,
    },
  },
  landingUserDesc: {
    color: '#fff',
    fontFamily: 'Helvetica Neue',
    fontSize: 12,
    fontStyle: 'italic',
    textAlign: 'center',
  },
  landingUserImage: {
    height: 101,
    width: 100,
    backgroundImage: `url(${president})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    borderRadius: '100%',
  },
  landingUserButton: {
    color: '#fff',
    fontSize: 14,
    fontWeight: 600,
    width: 148,
    height: 20,
  },
  serviceContainer: {
    backgroundColor: 'rgba(0, 0, 0, 0.33)',
    padding: 30,
    marginTop: 20,
    [theme.breakpoints.down('md')]: {
      backgroundColor: 'transparent',
    },
    [theme.breakpoints.down('sm')]: {
      backgroundColor: 'transparent',
      marginTop: 0,
    },
  },
  serviceTitle: {
    fontSize: 16,
    fontWeight: 900,
    fontFamily: 'Source Sans Pro',
  },
  serviceSubText: {
    fontSize: 16,
    color: 'white',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      color: '#000',
    },
  },
  serviceDesc: {
    margin: 0,
    fontSize: 15,
    marginTop: 0,
    textAlign: 'center',
    fontFamily: 'Source Sans Pro',
  },
  serviceIcon: {
    width: 38,
    height: 38,
  },
  serviceItem: {
    height: 261,
    width: 301,
    borderRadius: 17,
    backgroundColor: '#393939',
    color: 'white',
    padding: 20,
    [theme.breakpoints.down('sm')]: {
      height: 280,
      width: '100%',
    },
  },
  year50Container: {
    [theme.breakpoints.down('sm')]: {
      backgroundImage: `url(${bg})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'left top',
      backgroundSize: 'cover',
      height: 350,
    },
  },
  serviceBottom: {
    [theme.breakpoints.up('lg')]: {
      marginTop: 40,
    },
  },
})

const svgSignInPath =
  'M14.314419,7.75587903 C14.3964501,7.86525398 14.4374656,7.98830056 14.4374656,8.12501878 C14.4374656,8.26173699 14.3964501,8.38478357 14.314419,8.49415852 L7.54685701,15.1796895 C7.43748206,15.2890644 7.32127161,15.3437516 7.19822503,15.3437516 C7.07517844,15.3437516 6.95896799,15.302736 6.84959304,15.220705 L6.56248435,14.8925808 C6.45310941,14.8105497 6.39842224,14.7011748 6.39842224,14.5644565 C6.39842224,14.4277383 6.45310941,14.3046918 6.56248435,14.1953168 L11.9765339,8.82228274 L0.492186327,8.82228274 C0.355468111,8.82228274 0.239257033,8.77443108 0.143554345,8.67872839 C0.047851657,8.5830257 0,8.46681463 0,8.33009641 L0,7.91994114 C0,7.78322292 0.047851657,7.66701185 0.143554345,7.57130916 C0.239257033,7.47560647 0.355468111,7.42775481 0.492186327,7.42775481 L11.9765339,7.42775481 L6.56248435,2.05472075 C6.45310941,1.9453458 6.39842224,1.82229922 6.39842224,1.685581 C6.39842224,1.54886279 6.45310941,1.43948784 6.56248435,1.35745679 L6.84959304,1.02933257 C6.95896799,0.947301514 7.07517844,0.906285986 7.19822503,0.906285986 C7.32127161,0.906285986 7.43748206,0.947301514 7.54685701,1.02933257 L14.314419,7.75587903 Z M20.9999499,14.0312547 C20.9999499,14.5781282 20.8085439,15.0429712 20.4257326,15.4257826 C20.0429212,15.808594 19.5780781,16 19.0312046,16 L13.617155,16 C13.4804368,16 13.3642257,15.9521483 13.2685231,15.8564457 C13.1728204,15.760743 13.1249687,15.6445319 13.1249687,15.5078137 L13.1249687,15.1796895 C13.1249687,15.0429712 13.1728204,14.9267602 13.2685231,14.8310575 C13.3642257,14.7353548 13.4804368,14.6875031 13.617155,14.6875031 L19.0312046,14.6875031 C19.2226106,14.6875031 19.3798366,14.6259798 19.5028832,14.5029333 C19.6259298,14.3798867 19.6874531,14.2226607 19.6874531,14.0312547 L19.6874531,2.21878286 C19.6874531,2.02737685 19.6259298,1.87015088 19.5028832,1.74710429 C19.3798366,1.62405771 19.2226106,1.56253442 19.0312046,1.56253442 L13.617155,1.56253442 C13.4804368,1.56253442 13.3642257,1.51468276 13.2685231,1.41898008 C13.1728204,1.32327739 13.1249687,1.20706631 13.1249687,1.0703481 L13.1249687,0.742223877 C13.1249687,0.605505662 13.1728204,0.489294584 13.2685231,0.393591896 C13.3642257,0.297889208 13.4804368,0.250037551 13.617155,0.250037551 L19.0312046,0.250037551 C19.5780781,0.250037551 20.0429212,0.441443553 20.4257326,0.824254932 C20.8085439,1.20706631 20.9999499,1.67190937 20.9999499,2.21878286 L20.9999499,14.0312547 Z'

class Service extends React.Component {
  render() {
    const {classes} = this.props

    return (
      <Grid container className={classes.container}>
        <Grid item xs={12} md={12} className={classes.year50Container}>
          <Hidden lgUp={true}>
            <Grid container justify="center">
              <Grid item xs={12} md={10}>
                <div className={classes.landingUserSmall}>
                  <Grid container justify="center">
                    <Grid item xs={4}>
                      <div className={classes.landingUserImage} />
                    </Grid>
                    <Grid item xs={8}>
                      <p className={classes.landingUserDesc} style={{textAlign: 'left'}}>
                        Mr. Quirino (Gary) D’Alessandro. Founder
                      </p>
                      <Button
                        component={Link}
                        to="/about"
                        variant="contained"
                        color="primary"
                        className={classes.landingUserButton}
                      >
                        Click here
                      </Button>
                    </Grid>
                  </Grid>
                </div>
                <div className={classes.toolbar}>
                  <Typography>
                    <span className={classes.year50}>Celebrating 50 Years</span>
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </Hidden>
        </Grid>
        <Hidden mdDown={true}>
          <Grid item xs={12}>
            <Grid container justify="center" style={{height: 436}}>
              <Grid item xs={12} lg={9} />
              <Grid item xs={12} lg={3}>
                <div className={classes.landingUser}>
                  <Grid container justify="center">
                    <div className={classes.landingUserImage} />
                    <p className={classes.landingUserDesc}>
                      Mr. Quirino (Gary) D’Alessandro. Founder
                    </p>
                    <Button
                      component={Link}
                      to="/about"
                      variant="contained"
                      color="primary"
                      className={classes.landingUserButton}
                    >
                      Click here
                    </Button>
                  </Grid>
                </div>
                <div className={classes.toolbar}>
                  <Typography>
                    <h1 className={classes.year50}>50 Years</h1>
                    <p className={classes.year50Desc}>
                      Lanzo celebrates 50 years of delivering quality projects and improving the
                      quality of life.
                    </p>
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Hidden>
        <Hidden lgUp={true}>
          <Grid item xs={12} md={12}>
            <SlideMenu
              activeIcon="Login"
              context={this.context}
              menus={[
                {
                  label: 'Employees Login',
                  url: 'https://myaccess.lanzo.org',
                  svgPath: svgSignInPath,
                  type: 'external',
                },
                {label: 'Customers Login', url: '/login', svgPath: svgSignInPath, type: 'external'},
                {
                  label: 'Investors Login',
                  url: 'https://lanzoreports.com',
                  svgPath: svgSignInPath,
                  type: 'external',
                },
                {label: 'Sub Contractors Login', url: '/subcontractor', svgPath: svgSignInPath},
              ]}
            />
          </Grid>
        </Hidden>
        <Grid item xs={12} md={12}>
          <Grid container justify="center" className={classes.serviceContainer}>
            <Grid container justify="center">
              <Grid item xs={12} md={8}>
                <Grid container justify="center">
                  <p className={classes.serviceSubText}>
                    Lanzo Construction Company offers various services including but not limited to
                    Heavy Civil Construction, Design Build Services, Civil Infrastructure Systems,
                    WWTP Systems, and Trenchless Rehabilitations Services.
                  </p>
                </Grid>
              </Grid>
            </Grid>

            <Grid container justify="center">
              <Grid item xs={12}>
                <Grid container justify="center">
                  <Grid item xs={12} md={4} lg={3} sm={5} style={{marginBottom: 20}}>
                    <ExternalLink
                      /*to="https://www.lanzo.net/construction.html"*/
                      style={{textDecoration: 'none'}}
                    >
                      <div className={classes.serviceItem}>
                        <Grid container justify="center">
                          <Grid item xs={12}>
                            <Grid container justify="center">
                              <img src={construction} className={classes.serviceIcon} />
                            </Grid>
                          </Grid>
                          <p className={classes.serviceTitle}>Construction Division</p>
                          <p className={classes.serviceDesc}>
                            Building and Restoring sustainable infrastructure to support the needs
                            of our clients.
                          </p>
                        </Grid>
                      </div>
                    </ExternalLink>
                  </Grid>
                  <Grid item xs={12} md={4} lg={3} sm={5} style={{marginBottom: 20}}>
                    <ExternalLink
                      /*to="https://www.lanzo.net/trenchless.html"*/
                      style={{textDecoration: 'none'}}
                    >
                      <div className={classes.serviceItem}>
                        <Grid container justify="center">
                          <Grid item xs={12}>
                            <Grid container justify="center">
                              <img src={trenchless} className={classes.serviceIcon} />
                            </Grid>
                          </Grid>
                          <p className={classes.serviceTitle}>Trenchless Division</p>
                          <p className={classes.serviceDesc}>
                            Delivering innovative trenchless technology solutions to rehabilitate
                            the world's diverse infrastructure. Where digging just doesn't make
                            sense.
                          </p>
                        </Grid>
                      </div>
                    </ExternalLink>
                  </Grid>
                  {/* <Grid item xs={12} md={4} lg={3} sm={5} style={{marginBottom: 20}}>
                    <Link to="/soon" style={{textDecoration: 'none'}}>
                      <div className={classes.serviceItem}>
                        <Grid container justify="center">
                          <Grid item xs={12}>
                            <Grid container justify="center">
                              <img src={asphalt} className={classes.serviceIcon} />
                            </Grid>
                          </Grid>
                          <p className={classes.serviceTitle}>Asphalt & Concrete Division</p>
                          <p className={classes.serviceDesc}>
                            Asphalt and Concrete Paving solutions including Roadway, Heavy Highway,
                            Neighborhood, and Park Projects.
                          </p>
                        </Grid>
                      </div>
                    </Link>
                  </Grid> */}
                  <Grid item xs={12} md={4} lg={3} sm={5} style={{marginBottom: 20}}>
                    <Link /*to="/soon"*/ style={{textDecoration: 'none'}}>
                      <div className={classes.serviceItem}>
                        <Grid container justify="center">
                          <Grid item xs={12}>
                            <Grid container justify="center">
                              <img src={engineering} className={classes.serviceIcon} />
                            </Grid>
                          </Grid>
                          <p className={classes.serviceTitle}>Engineering Services Division</p>
                          <p className={classes.serviceDesc}>
                            A fully integrated Engineering Staff for Design, Build, and Expert
                            Services.
                          </p>
                        </Grid>
                      </div>
                    </Link>
                  </Grid>
                  {/* <Grid item xs={12} md={4} lg={3} sm={5} style={{marginBottom: 20}}>
                    <Link to="/soon" style={{textDecoration: 'none'}}>
                      <div className={classes.serviceItem}>
                        <Grid container justify="center">
                          <Grid item xs={12}>
                            <Grid container justify="center">
                              <img src={tunneling} className={classes.serviceIcon} />
                            </Grid>
                          </Grid>
                          <p className={classes.serviceTitle}>
                            Tunnels & Directional Boring Division
                          </p>
                          <p className={classes.serviceDesc}>
                            We offer experienced and equipped staff of competent drilling
                            capabilities to turn key provide or round out our Infrastructure
                            Packages.
                          </p>
                        </Grid>
                      </div>
                    </Link>
                  </Grid> */}
                  {/* <Grid item xs={12} md={4} lg={3} sm={5} style={{marginBottom: 20}}>
                    <Link to="/soon" style={{textDecoration: 'none'}}>
                      <div className={classes.serviceItem}>
                        <Grid container justify="center">
                          <Grid item xs={12}>
                            <Grid container justify="center">
                              <img src={manufacturing} className={classes.serviceIcon} />
                            </Grid>
                          </Grid>
                          <p className={classes.serviceTitle}>Manufacturing Division</p>
                          <p className={classes.serviceDesc}>
                            Lanzo has installed over 15,000,000 lineal feet of CIPP in sizes from 4"
                            through 144". We manufacture a High Quality Liner Tube meeting all the
                            stand alone structural characteristics and quality standards enforced by
                            ASTM F126 and F1743.
                          </p>
                        </Grid>
                      </div>
                    </Link>
                  </Grid> */}
                  {/* <Grid item xs={12} md={4} lg={3} sm={5} style={{marginBottom: 20}}>
                    <Link to="/soon" style={{textDecoration: 'none'}}>
                      <div className={classes.serviceItem}>
                        <Grid container justify="center">
                          <Grid item xs={12}>
                            <Grid container justify="center">
                              <img src={emergency} className={classes.serviceIcon} />
                            </Grid>
                          </Grid>
                          <p className={classes.serviceTitle}>Emergency Services Division</p>
                          <p className={classes.serviceDesc}>
                            Lanzo Construction Company is one of this Nation's leading infrastructure design
                            and construction specialists.
                          </p>
                        </Grid>
                      </div>
                    </Link>
                  </Grid> */}
                  {/* <Grid item xs={12} md={4} lg={3} sm={5} style={{marginBottom: 20}}>
                    <Link to="/soon" style={{textDecoration: 'none'}}>
                      <div className={classes.serviceItem}>
                        <Grid container justify="center">
                          <Grid item xs={12}>
                            <Grid container justify="center">
                              <img src={plantWork} className={classes.serviceIcon} />
                            </Grid>
                          </Grid>
                          <p className={classes.serviceTitle}>Plant Division</p>
                          <p className={classes.serviceDesc}>
                            Lanzo Construction Company is one of this Nation's leading infrastructure design
                            and construction specialists.
                          </p>
                        </Grid>
                      </div>
                    </Link>
                  </Grid> */}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  }
}

Service.displayName = 'Service'

Service.contextTypes = {
  router: PropTypes.object.isRequired,
}

export default compose(
  withStyles(styles),
  withWidth(),
)(Service)
